import {
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

export const inputStyles = {
  width: '100%',

  'input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  },
  'input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  },

  '&:hover': {
    '&:has(.MuiInputBase-root.Mui-error)': {
      '.MuiFormLabel-root': {
        color: `${primaryColors.orange} !important`
      }
    },
    '&:has(.MuiInputBase-root.Mui-error > .MuiInputBase-input:focus)': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${primaryColors.orange} !important`
      },
      '.MuiFormLabel-root': {
        color: `${primaryColors.orange} !important`
      }
    },
    '.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.orange} !important`
    },
    '.Mui-error.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.orange} !important`
    },
    '.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.white} !important`
    },
    '.MuiFormLabel-root': {
      '&[data-shrink="true"]': {
        color: `${primaryColors.white} !important`,
        textTransform: 'uppercase'
      },
      '&:hover': {
        color: 'inherit'
      }
    }
  },

  '&:has(.MuiInputBase-root.Mui-error > .MuiInputBase-input:focus)': {
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.orange} !important`
    },
    '.MuiFormLabel-root': {
      '&:hover': {
        color: `${primaryColors.orange} !important`
      },
      '&[data-shrink="true"]': {
        color: `${primaryColors.orange} !important`
      }
    }
  },

  '&:has(.MuiInputBase-root > .MuiInputBase-input:focus)': {
    '.MuiFormLabel-root': {
      '&[data-shrink="true"]': {
        color: `${primaryColors.white} !important`
      }
    }
  },

  '.MuiInputBase-root::first-letter': {
    textTransform: 'capitalize'
  },

  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${whiteShades.shade1} !important`
  },
  '.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.orange} !important`
  },

  '.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.orange} !important`
  },

  '.Mui-error.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.orange} !important`
  },

  '.MuiInputBase-root input': {
    textTransform: 'none'
  },

  '.MuiInputBase-root:has(textarea)': {
    padding: '0.5rem'
  },

  '.MuiFormLabel-root': {
    color: `${whiteShades.shade1} !important`,
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    transform: 'translate(14px, 7px) scale(1)',
    '&[data-shrink="true"]': {
      transform: 'translate(14px, -9px) scale(0.75)'
    },
    '&.Mui-disabled': {
      textTransform: 'uppercase !important'
    }
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${whiteShades.shade1} !important`,
    top: '-4px',
    '&:hover': {
      borderColor: `${primaryColors.white}`
    },
    'legend span': {
      fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
      fontSize: '0.65rem',

      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',

      '&[aria-hidden="true"]': {
        paddingLeft: '0',
        paddingRight: '0'
      }
    }
  },

  '.Mui-disabled': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${whiteShades.shade1}`
    },
    '&.MuiFormLabel-root': {
      color: `${whiteShades.shade1} !important`,
      textTransform: 'uppercase'
    }
  },

  '.Mui-focused.Mui-error': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${primaryColors.orange}`
    },
    '&.MuiFormLabel-root': {
      color: `${primaryColors.orange} !important`,
      textTransform: 'uppercase',
      '&:hover': {
        color: `${primaryColors.orange} !important`
      }
    }
  },

  '.MuiAutocomplete-root.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline':
    {
      borderColor: primaryColors.orange
    },

  '.MuiInputBase-root .Mui-error:hover .MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${primaryColors.orange}`
  },

  '.MuiFormHelperText-root': {
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    margin: 0,

    '&.Mui-error': {
      color: primaryColors.orange
    }
  },

  '.MuiInputBase-root.Mui-disabled': {
    color: whiteShades.shade1,
    WebkitTextFillColor: whiteShades.shade1,
    textTransform: 'none',

    borderRadius: '0.25rem',
    '.MuiOutlinedInput-notchedOutline': {
      backgroundColor: transparentColors.whiteShade2,
      textTransform: 'none'
    }
  },

  '.MuiOutlinedInput-root': {
    color: primaryColors.white,
    '&:has(.MuiInputBase-input:focus)': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${primaryColors.white} !important`
      }
    }
  },

  '.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.white}`
  },

  '&.MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
    {
      borderColor: `${primaryColors.white}`
    },

  '.MuiInputBase-input': {
    fontSize: '0.875rem',
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 400,

    padding: '0.5rem 0.75rem',
    '&::-webkit-scrollbar': {
      width: '0.5rem'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: transparentColors.orangeShade4,
      borderRadius: '0.5rem',
      cursor: 'pointer'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: transparentColors.transparent,
      borderRadius: '0.5rem'
    },
    '&::placeholder': {
      color: whiteShades.shade1,
      opacity: 1,
      fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
      fontWeight: 400
    }
  },

  '.MuiInputBase-input.MuiInputBase-inputMultiline': {
    padding: '0 0.25rem'
  },

  '.MuiOutlinedInput-input': {
    height: '1.125rem'
  }
}

// Unit shown inside the field (e.g. "zł" on a price input), muted, so it
// reads as a hint next to the value rather than as part of it.
export const inputAdornmentStyles = {
  '.MuiTypography-root': {
    color: whiteShades.shade1,
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontSize: '0.875rem'
  }
}
